import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  ReturnReasonFirestoreResponse,
  CreateReturnReasonDto,
  UpdateReturnReasonDto,
  DeleteReturnReasonResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const ReturnReasonResponseSchema = ReturnReasonFirestoreResponse;
export const CreateReturnReasonSchema = CreateReturnReasonDto;
export const UpdateReturnReasonSchema = UpdateReturnReasonDto;

// ====== Type Exports ======
export type ReturnReasonResponse = z.infer<typeof ReturnReasonFirestoreResponse>;
export type CreateReturnReason = z.infer<typeof CreateReturnReasonDto>;
export type UpdateReturnReason = z.infer<typeof UpdateReturnReasonDto>;

// API factory function
export function createReturnReasonsApi(client: TypedApiClient) {
  return {
    getReturnReasons: (): Promise<ReturnReasonResponse[]> => {
      return client.get('/return-reasons', {
        responseSchema: z.array(ReturnReasonFirestoreResponse),
      });
    },

    createReturnReason: (data: CreateReturnReason): Promise<ReturnReasonResponse> => {
      return client.post('/return-reasons', {
        data,
        requestSchema: CreateReturnReasonDto,
        responseSchema: ReturnReasonFirestoreResponse,
      });
    },

    updateReturnReason: (id: string, data: UpdateReturnReason): Promise<ReturnReasonResponse> => {
      return client.patch(apiPath`/return-reasons/${id}`, {
        data,
        requestSchema: UpdateReturnReasonDto,
        responseSchema: ReturnReasonFirestoreResponse,
      });
    },

    deleteReturnReason: (id: string): Promise<z.infer<typeof DeleteReturnReasonResponseDto>> => {
      return client.delete(apiPath`/return-reasons/${id}`, {
        responseSchema: DeleteReturnReasonResponseDto,
      });
    },
  };
}
